import { getScrollWidth } from './get-scroll-width.js';
var getLockStyles = function getLockStyles(_ref) {
  var disableBodyPadding = _ref.disableBodyPadding;
  var scrollWidth = disableBodyPadding ? null : getScrollWidth();
  var styles = "body {\n        --removed-scroll-width: ".concat(scrollWidth, "px;\n        touch-action: none;\n        overflow: hidden !important;\n        position: relative !important;\n        ").concat(scrollWidth ? "padding-right: var(--removed-scroll-width) !important;" : "", "\n        ");
  return styles;
};
export { getLockStyles };